import React, { FC } from 'react';

import Logo from './components/Logo';
import User from './components/User';
import { Wrapper, ColumnLeft, SRightSection, SGitInfo } from './style';

const Navbar: FC = () => {
  return (
    <Wrapper>
      <ColumnLeft>
        <Logo />
      </ColumnLeft>
      <SRightSection>
        <SGitInfo />
        <User />
      </SRightSection>
    </Wrapper>
  );
};

export default Navbar;
